// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1D19h","rightAdornment":"Header_rightAdornment__32UJw"};